// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__Iv4Mh","loadIcon":"Loader_loadIcon__RSKt7","spin":"Loader_spin__I0Tfd"};